//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/SelectEdge.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AngularDimension",0,"Expression",0],[1,"CuttingClearance",0,"Expression",0],[1,"CuttingDistance",0,"Expression",0],[0,"OffsetDirection",1,"Direction",0],[0,"OffsetDistance",1,0],[0,"PreviousWorkPart",1,"Part",0],[1,"RadiusDimension",0,"Expression",0],[0,"RotateDirection",1,"Direction",0],[1,"SelectComponent",0,"Assemblies.SelectComponent",0],[0,"SelectDataFile",1,0],[1,"SelectObject",0,"SelectNXObjectList",0],[0,"SelectPoint",1,"Point",0],[0,"SlugEdgeForTypeTwo",1,"Edge",0],[1,"SlugRetentionBooleanData",0,"GeometricUtilities.BooleanOperation",0],[1,"SlugRetentionEdge",0,"SelectEdge",0],[0,"SlugRetentionFeature",1,"Features.Feature",0],[0,"TargetBodyForSubtract",1,"Body",0],[0,"Type",1,0]],[],[]];
SPLM.Tooling.SlugRetentionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SlugRetentionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.SlugRetentionBuilder.Types = Object.freeze({
    "TypeFirst" : "TypeFirst", "TypeSecond" : "TypeSecond", "Edit" : "Edit"});

export default SPLM;